import {Component, OnInit} from '@angular/core';
import {Vendor} from '../../../../types/data.types';
import {DirectoryService} from '../../../../services/directory.service';
import {UrlService} from '../../../../services/url.service';
import {AbstractListComponent} from '../abstract-list.component';
import {EmptyRowService} from '../../../../services/empty-row.service';
import {PhoneTransformer} from '../../../../services/transformer.service';

declare const $: any;

@Component({
    selector: 'vendors-list',
    templateUrl: './vendors-list.component.html',
    styleUrls: ['./vendors-list.component.scss']
})
export class VendorsListComponent extends AbstractListComponent implements OnInit {

    constructor(
        public directoryService: DirectoryService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService
    ) {
        super(directoryService, urlService, emptyRowService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.s.push(this.directoryService.onDataReceived.subscribe((response) => {
            if (response.id !== 'vendors') return;
            this.data = [];
            const entities = response.data.entities || [];
            entities.forEach((data) => {
                const vendor = new Vendor();
                if(data.id) vendor.id = data.id;
                if(data.minNumberOfEmployees) vendor.minNumberOfEmployees = data.minNumberOfEmployees;
                if(data.maxNumberOfEmployees) vendor.maxNumberOfEmployees = data.maxNumberOfEmployees;
                if(data.addresses) vendor.addresses = data.addresses;
                if(data.categories) vendor.categories = data.categories.map(i => ({...i, itemName: i.name}));
                if(data.logo) vendor.logo = data.logo;
                if(data.name) vendor.name = data.name;
                if(data.paymentMethods) vendor.paymentMethods = data.paymentMethods.map(i => ({...i, itemName: i.name}));
                if(data.phones) vendor.phones = data.phones;
                if(data.photos) vendor.photos = data.photos;
                if(data.products) vendor.products = data.products;
                if(data.serviceAreas) vendor.serviceAreas = data.serviceAreas;
                if(data.userCompany) vendor.userCompany = data.userCompany;
                if(data.userCorporations) vendor.userCorporations = data.userCorporations;
                if(data.yearEstablished) vendor.yearEstablished = data.yearEstablished;
                if(data.returnPolicy) vendor.returnPolicy = data.returnPolicy;
                if(data.bonded) vendor.bonded = data.bonded;
                if(data.warrantyTerms) vendor.warrantyTerms = data.warrantyTerms;
                if(data.workersCompensation) vendor.workersCompensation = data.workersCompensation;
                if(data.liabilityInsurance) vendor.liabilityInsurance = data.liabilityInsurance;
                if(data.membership) vendor.membership = data.membership;
                if(data.writtenContract) vendor.writtenContract = data.writtenContract;
                if(data.licences) vendor.licences = data.licences;
                if(data.services) vendor.services = data.services;
                if(data.userCompany) vendor.userCompany = data.userCompany;
                if(data.verified) vendor.verified = data.verified;
                if(data.companies) vendor.companies = data.companies;
                if(data.corporations) vendor.corporations = data.corporations.map(c => ({...c, itemName: c.name}));
                if(data.corporations && data.companies) vendor.corporationsAndLists = data.corporations.concat(data.companies.map(c => ({name: c.vendorListName})));
                if(data.addresses) vendor.primaryCity = this.getAddress(data.addresses);
                if(data.phones) vendor.primaryPhone = this.getPhone(data.phones);
                if(data.sponsoredFrom) vendor.sponsoredFrom = data.sponsoredFrom;
                if(data.sponsoredTo) vendor.sponsoredTo = data.sponsoredTo;

                vendor.isCanEdit = this.canEditVendor(data);
                vendor.isCanDelete = this.canEditVendor(data);

                const selItem = this.directoryService.selectedItemData;
                if (selItem && selItem.id == data.id) {
                    vendor.checked = true;
                    this.directoryService.toggleDetailedView(vendor, true);
                }

                this.data.push(vendor);
            });
            this.fillEmptyRow();
        }));
    }

    public getPhone(data) {
        if(data.length > 0) {
            let index = 0;
            const matchIndex = data.findIndex(item => item.isPrimaryPhone);
            if (matchIndex != -1)
                index = matchIndex;
            if (data[index].phone.match('^[0-9]+$'))
                return PhoneTransformer.stringToPhone(data[index].phone);
            else
                return data[index].phone.substr();
        } else
            return '';
    }

    public getAddress(data) {
        if(data.length > 0) {
            let index = 0;
            const matchIndex = data.findIndex(item => item.primary);
            if (matchIndex != -1)
                index = matchIndex;
            return data[index].city || '';
        } else
            return '';
    }

    public canEditVendor(vendor) {
        return ((!vendor.public && vendor.isCanEdit && vendor.corporations.length > 0 && vendor.companies.length === 0) || this.directoryService.userIsSuperAdmin());
    }

    public onTableClicked(event) {
        if(event.target.className.indexOf('list-items__btn') != -1)
            this.showHint(event);
    }

    showHint(e) {
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/vendors-list/vendors-list.component.ts